import t from"./_baseCreate.js";import o from"./_getPrototype.js";import r from"./_isPrototype.js";function e(e){return"function"!=typeof e.constructor||r(e)?{}:t(o(e))}export{e as default};
//# sourceMappingURL=_initCloneObject.js.map
